import * as tslib_1 from "tslib";
import axios from 'axios';
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { Progress, Icon, Tooltip, Input, Modal, Button, Upload } from '@h3/antd-vue';
import { UploadStatus } from "../../../common/controls/upload-control";
let FileList = class FileList extends Vue {
    constructor() {
        super(...arguments);
        this.isDown = false;
        this.currentFile = ''; //当前更新文件
        this.isChange = false;
        this.DownUrlData = []; //处理之后的数据
        this.precents = [];
        this.status = []; // 保存单个文件状态
        this.timer = 0;
        this.nameWidth = 0;
        this.downLoadText = '';
        this.downLoadObj = {};
        this.downLoadVisible = false;
        /**
         * @desc 处理时间
         */
        this.format = function (time, format = "YYYY-MM-dd HH:mm:sss") {
            let t = new Date(time);
            let o = {
                "M+": t.getMonth() + 1,
                "d+": t.getDate(),
                "H+": t.getHours(),
                "m+": t.getMinutes(),
                "s+": t.getSeconds(),
                "q+": Math.floor((t.getMonth() + 3) / 3),
                "f+": t.getMilliseconds(),
            };
            if (/(Y+)/.test(format)) {
                format = format
                    .replace(RegExp.$1, t.getFullYear() + "")
                    .substr(4 - RegExp.$1.length);
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length));
                }
            }
            return format;
        };
        this.uniqueKey = ''; //  每个上传附件的唯一key
    }
    listChange(list = []) {
        const _this = this;
        this.isChange = false;
        let Timer;
        if (!list.length) {
            this.DownUrlData = [];
            return;
        }
        clearTimeout(Timer);
        Timer = setTimeout(() => {
            if (this.isChange) {
                return;
            }
            this.isChange = true;
            _this.initDownUrls(this.downUrls, '2');
        }, 500);
    }
    eventListChange(arr = []) {
        // 跟新文件上传进度
        // console.log(arr, 'arr---');
        if (arr && arr.length > 0) {
            this.autoStep();
        }
    }
    removeFile(file, key) {
        const res = Object.assign({}, file, { status: UploadStatus.Delete }) || null;
        if (this.precents && this.precents.length > 0) {
            this.precents = this.precents.filter((item, idx) => {
                return idx !== key;
            });
        }
        console.log(res, 'res');
        this.$emit('rmFile', res);
        // return res;
    }
    previewFile(file) {
        // console.log(file, 'file');
        this.$emit('previewFile', file);
    }
    uploadFile(data) {
        return data;
    }
    /*
     * @desc 格式化文件大小
     */
    initSize(item) {
        if (item.size !== undefined) {
            let size = item.size;
            if (item.response && item.response.data && item.response.data.fileSize) {
                size = item.response.data.fileSize;
            }
            let k = 1024; // 比特 字节大小
            let m = 1048576; // 兆字节大小
            let num = k; // 默认使用的几算大小
            let str = "KB";
            if (size > m) {
                num = m;
                str = "M";
            }
            if (size === 0) {
                return `0${str}`;
            }
            else if (size) {
                return `${(size / num).toFixed(2)}${str}`;
            }
            else {
                return "";
            }
        }
        else if (item.fileSize !== undefined) {
            let size = item.fileSize;
            if (item.response && item.response.data && item.response.data.fileSize) {
                size = item.response.data.fileSize;
            }
            let k = 1024; // 比特 字节大小
            let m = 1048576; // 兆字节大小
            let num = k; // 默认使用的几算大小
            let str = "KB";
            if (size > m) {
                num = m;
                str = "M";
            }
            if (size === 0) {
                return `0${str}`;
            }
            else if (size) {
                return `${(size / num).toFixed(2)}${str}`;
            }
            else {
                return "";
            }
        }
    }
    isSupportCX() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //不支持畅写预览就显示下载（图片除外）
            // let type: string = file.type || file.response.data.mimeType;
            // if (type.indexOf("image") != -1) {
            // 	return false;
            // }
            // const isSupportCX = utils.isSupportCXFormat(file);
            // if(isSupportCX){
            // 	return false;
            // } else {
            // 	return true;
            // }
            // @ts-ignore
            // const formObj = JSON.parse(window.sessionStorage.getItem("formObj"));
            // const schemaCode = formObj.bizSchema.code
            // const token = localStorage.getItem("token");
            // let uri = `/api/ext/document/displaySecretTreaty?schemaCode=${schemaCode}`;
            // const isDev = process.env.NODE_ENV === "debug";
            // if (isDev) {
            // uri = uri.replace("/api", "");
            // } else {
            // uri = `${location.origin}` + uri;
            // }
            // const cfg = {
            // headers: {
            // 	"Content-Type": "application/json",
            // 	Authorization: `Bearer ${token}`,
            // },
            // } as any;
            // const ret = await axios.get(uri, cfg) as any;
            // this.isDown = ret&&!ret.data ? true : false
            this.isDown = this.controlOpts.isDownload;
        });
    }
    downLoadCancel() {
        this.downLoadVisible = false;
        this.downLoadText = '';
    }
    // 确认获取下载链接
    downLoadConfirm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const token = localStorage.getItem('token');
            const refId = this.downLoadObj.uid || '';
            let uri = `/api/ext/document/download/confirm?refId=${refId}&reason=${this.downLoadText}`;
            const isDev = process.env.NODE_ENV === 'debug';
            if (isDev) {
                uri = uri.replace('/api', '');
            }
            else {
                uri = `${location.origin}` + uri;
            }
            const cfg = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            };
            const ret = (yield axios.get(uri, cfg));
            if (ret && ret.data) {
                const downUrl = ret.data.url;
                const index = downUrl.lastIndexOf('/api');
                let str = downUrl.substring(index, downUrl.length);
                if (isDev) {
                    str = str.replace('/api', '');
                }
                else {
                    str = `${location.origin}` + str;
                }
                const cfg2 = {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                };
                const ret2 = (yield axios.get(str, cfg2));
                if (ret2 && ret2.errmsg) {
                    this.$message.error(ret2.errmsg);
                    return;
                }
                const blob = new Blob([ret2], {
                    type: ret2.type
                });
                const name = this.downLoadObj.name || '';
                const link = document.createElement('a');
                link.download = name;
                link.style.display = 'none';
                link.href = window.URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
                this.downLoadVisible = false;
                this.downLoadText = '';
            }
        });
    }
    getPercent(key) {
        let res = this.precents[key];
        if (!res)
            return 0;
        return res.percent;
    }
    getStatus(key) {
        if (!this.precents.length)
            return "done";
        let status = this.precents[key];
        if (status && status.status) {
            return this.transformStatus(status.status);
        }
        return "";
    }
    /**
     * @des 模拟更新进度条
     */
    autoStep() {
        // 防止开启多个定时器
        clearTimeout(this.timer);
        let isRpeat = false;
        this.precents = this.eventList.map((item, i) => {
            let { status, percent = 0, timer = -1, size = 0, response } = item;
            status = this.transformStatus(status);
            percent = this.getPercent(i);
            let step = 0;
            let ss = 300; // 默认每秒钟300k的上传速度
            if (status === "done" || status === "error") {
                percent = 100;
            }
            else {
                step = 100 / (size / ss / 1024);
                percent = percent + step;
                isRpeat = true;
            }
            // 状态更新
            if (response && !response.data) {
                status = "error";
            }
            return { percent, status };
        });
        // 调用自己
        if (isRpeat) {
            this.timer = window.setTimeout(this.autoStep, 1000);
        }
    }
    getColor(item) {
        if (item) {
            if (!this.precents.length)
                return "#17BC94";
            if (item.status === "error")
                return "#FF5500";
            return "#17BC94";
        }
    }
    getName(item) {
        if (item.hasOwnProperty("uploadName") && item.uploadName) {
            return item.uploadName;
        }
        if (item.response) {
            if (item.response.data.response) {
                return item.response.data.response.data.creater && item.response.data.response.data.creater.name;
            }
            else {
                return item.response.data.creater && item.response.data.creater.name;
            }
        }
        else if (item.creater) {
            // 关联映射
            if (item.creater.name) {
                return item.creater.name;
            }
        }
        return "";
    }
    getTime(item) {
        if (item.hasOwnProperty("uploadTime") && item.uploadTime) {
            return this.format(item.uploadTime);
        }
        if (item.response) {
            if (item.response.data.response) {
                return item.response.data.response.data.createdTime;
            }
            else {
                return item.response.data.createdTime;
            }
        }
        else if (item.createdTime) {
            return item.createdTime;
        }
        return "";
    }
    /**
     * @desc 下载文件
     */
    // downFile(file, idx, actions) {
    //   if (file.status === 2 || file.status === "done") {
    //     let val = this.downUrls[idx];
    //     let url = "";
    //     actions === "preview" ? (url = val.previewUrl) : (url = val.url);
    //     url && window.open(url);
    //     event && event.stopPropagation();
    //   }
    // }
    downFile(file, idx, actions) {
        this.downLoadObj = file;
        this.downLoadVisible = true;
        // 内审会结论不支持下载
        // const json = window.sessionStorage.getItem("formObj");
        // if (json) {
        // 	const formObj = JSON.parse(json);
        // 	const code = formObj.bizSheet.code
        // 	if(code=='leishenghy_n'){
        // 		this.$message.info("此附件保密协议等级较高，不支持下载！");
        // 		return
        // 	}
        // }
        // if (file.status === 2 || file.status === 'done') {
        // 	let val = this.downUrls[idx];
        // 	let url = '';
        // 	actions === 'preview' ? (url = val.previewUrl) : (url = val.url);
        // 	url && window.open(url);
        // 	event && event.stopPropagation();
        // }
    }
    // 更新文件
    upload(file) {
        this.currentFile = file;
    }
    beforeUpload(file) {
        const params = {
            newFile: file,
            oldFile: this.currentFile
        };
        this.uploadFile(params);
    }
    initFieName(name) {
        let size = 14; // 字的大小
        let len = name.length * size;
        if (len <= this.nameWidth)
            return name;
        let start = name.slice(0, 6);
        let idex = name.lastIndexOf(".");
        let middle = name.slice(idex - 6, idex);
        let end = name.slice(idex);
        return `${start}...${middle}${end}`;
    }
    /**
     * @desc 获取组件的宽度
     */
    getWidth() {
        let size = 0;
        // let el = document.querySelector(".file-list");
        // if (el) {
        //   size = el.clientWidth;
        // }
        // 修复第一个附件隐藏时 clientWidth 为 0 的bug -- Chaopeng.Li
        // 通过随机数 ref 取当前元素的 clientWidth
        if (this.$refs[this.uniqueKey]) {
            size = this.$refs[this.uniqueKey].clientWidth || 0;
        }
        this.nameWidth = Math.ceil(size * 0.7);
    }
    created() {
        const random = Math.random().toString();
        this.uniqueKey = random.split('.')[1];
    }
    mounted() {
        this.getWidth();
        window.addEventListener("resize", this.getWidth);
        let { downUrls } = this;
        downUrls = downUrls ? downUrls : [];
        this.status = downUrls.map((item) => item.status);
        this.$nextTick(() => {
            this.initDownUrls(downUrls, '1');
            this.isSupportCX();
        });
    }
    initDownUrls(urlData, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (type === '2') {
                if (urlData.length > this.DownUrlData.length) {
                    // 上传
                    let res = urlData.filter((item1) => !this.DownUrlData.some((item2) => item2.uid === item1.uid));
                    this.DownUrlData = [...this.DownUrlData, ...res];
                }
                else {
                    let res = this.DownUrlData.filter((item1) => !urlData.some((item2) => item2.uid === item1.uid));
                    let uid = (res[0] && res[0].uid) || '';
                    this.DownUrlData.forEach((j, idx) => {
                        if (j.uid === uid) {
                            this.DownUrlData.splice(idx, 1);
                        }
                    });
                    // 删除
                }
                return;
            }
            if (!urlData || (urlData && !urlData.length)) {
                return;
            }
            // if(!this.showRm){
            // 	return
            // }
            const token = localStorage.getItem('token');
            const isDev = process.env.NODE_ENV === 'debug';
            let uri = `/api/ext/document/getAttachmentByRefIds`;
            const cfg = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            };
            if (isDev) {
                uri = uri.replace('/api', '');
            }
            else {
                uri = `${location.origin}` + uri;
            }
            // @ts-ignore
            const formObj = JSON.parse(window.sessionStorage.getItem('formObj'));
            const schemaCode = formObj.bizSchema.code;
            const activityCode = formObj.activityCode;
            const refIdList = urlData.map((dataItem) => {
                return (dataItem.response &&
                    dataItem.response.data &&
                    dataItem.response.data.refId);
            }) || [];
            const params = {
                schemaCode: schemaCode,
                activityCode: activityCode,
                refIdList: refIdList
            };
            const { errcode, data, detailMsg, resultMsg, errmsg } = (yield axios.post(uri, params, cfg));
            if (errcode === 0) {
                const editPermission = data || {};
                Object.keys(editPermission).forEach((key) => {
                    urlData.forEach((i) => {
                        const refId = i.response.data.refId;
                        if (refId === key) {
                            i.isUpload = editPermission[key].isCanEdit;
                            // i.isUpload = true
                            i.name = editPermission[key].fileName;
                            i.size = editPermission[key].fileSize;
                            i.response.data.creater.name = editPermission[key].userName;
                            i.response.data.createdTime = editPermission[key].lastUpdateTime;
                        }
                    });
                });
            }
            else {
                this.$message.error(errmsg || detailMsg || resultMsg || '服务器繁忙');
            }
            this.DownUrlData = urlData;
            console.log('urlData===============', urlData);
        });
    }
    transformStatus(status) {
        switch (status) {
            case UploadStatus.Delete:
                return "removed";
            case UploadStatus.Uploading:
                return "uploading";
            case UploadStatus.Done:
                return "done";
            case UploadStatus.Error:
                return "error";
            case UploadStatus.FileToImg:
                return "fileToImg";
            default:
                return status;
        }
    }
    previewPdf(file) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('file', file);
            const refId = file.response && file.response.data && file.response.data.refId;
            if (refId) {
                const token = localStorage.getItem('token');
                let uri = `/api/ext/document/pdf/getPreviewInfo?refId=${refId}`;
                const isDev = process.env.NODE_ENV === 'debug';
                if (isDev) {
                    uri = uri.replace('/api', '');
                }
                else {
                    uri = `${location.origin}` + uri;
                }
                const cfg = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                };
                const ret = (yield axios.get(uri, cfg));
                if (ret && ret.data) {
                    console.log('downloadUrl', ret.data.downloadUrl);
                    let url = ret.data.downloadUrl;
                    let name = ret.data.fileName;
                    url = url.split('://')[1];
                    let protocol = location.protocol + '//';
                    console.log('protocol', protocol);
                    let newUrl = encodeURIComponent(protocol + url + `&fileName=${name}`);
                    console.log('newUrl', newUrl);
                    // name = encodeURIComponent(name)
                    // url=encodeURIComponent(url+`&fileName=${name}`)
                    // console.log('encodeUrl',url)
                    // window.open(`http://cloudpivot-dev.xgjktech.com.cn/yunshu-file-system/web/dist/#/pdf-view?file=${newUrl}`);
                    window.open(`${location.origin}/yunshu-file-system/web/dist/#/pdf-view?file=${newUrl}`);
                }
                else {
                    this.$message.error(ret.errmsg);
                }
            }
        });
    }
    getDownLoadText() {
        let text = '下载';
        if (localStorage.getItem('locale') === 'en') {
            text = 'DownLoad';
        }
        return text;
    }
    getUpdateText() {
        let text = '更新';
        if (localStorage.getItem('locale') === 'en') {
            text = 'Update';
        }
        return text;
    }
    getPreviewText() {
        //preview
        let text = 'pdf预览';
        if (localStorage.getItem('locale') === 'en') {
            text = 'PDF-Preview';
        }
        return text;
    }
    getDownLoadReason() {
        let text = '请输入您下载附件的原因...';
        if (localStorage.getItem('locale') === 'en') {
            text = 'Please Input DownLoad Reason...';
        }
        return text;
    }
    getSystemText() {
        let text = '您的本次下载会被系统记录';
        if (localStorage.getItem('locale') === 'en') {
            text = 'Your download will be recorded by the system.';
        }
        return text;
    }
    getOpText(op) {
        //preview
        let text = op;
        if (localStorage.getItem('locale') === 'en' && op === '确定') {
            text = 'Sure';
        }
        if (localStorage.getItem('locale') === 'en' && op === '取消') {
            text = 'Cancel';
        }
        return text;
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], FileList.prototype, "controlOpts", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], FileList.prototype, "list", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], FileList.prototype, "showRm", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], FileList.prototype, "downUrls", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], FileList.prototype, "eventList", void 0);
tslib_1.__decorate([
    Prop()
], FileList.prototype, "parentKey", void 0);
tslib_1.__decorate([
    Watch('list')
], FileList.prototype, "listChange", null);
tslib_1.__decorate([
    Watch("eventList")
], FileList.prototype, "eventListChange", null);
tslib_1.__decorate([
    Emit()
], FileList.prototype, "uploadFile", null);
FileList = tslib_1.__decorate([
    Component({
        name: "file-list",
        components: {
            AProgress: Progress,
            AIcon: Icon,
            ATooltip: Tooltip,
            AInput: Input,
            AModal: Modal,
            AButton: Button,
            AUpload: Upload
        },
    })
], FileList);
export default FileList;
